module.exports = __webpack_public_path__ + "img/王称堌镇-c.040e799b.png";